/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCurrencyKrw = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m3 2 1.512 6h4.976L11 2h2l1.512 6h4.976L21 2h2l-1.5 6H23v2h-2l-.5 2H23v2h-3l-2 8h-2l-2.015-8h-3.97L8 22H6l-2-8H1v-2h2.5L3 10H1V8h1.5L1 2zm4.976 12H6.024L7 17.877zm10 0h-1.952L17 17.877zm-8.992-4H5.016l.504 2h2.96zm3.993 0h-1.954l-.504 2h2.962zm6.007 0h-3.968l.504 2h2.96zM12 6.123 11.527 8h.946z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCurrencyKrw as CurrencyKrw };
